import React from "react";
import { Col, Form, Input, Modal, Row, Select, Tooltip } from "antd";
import { InfoCircleOutlined, MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Option } from "antd/es/mentions";
import { COMPANY_COUNTRY_CODE, REGIONS } from "../../../../../constants/CompanyConstants";
import roles from "../../../../../roles";

const AddUserModal = ({
  visible,
  onCancel,
  onOk,
  form,
  formEmail,
  setFormEmail,
  formPhone,
  setFormPhone,
  formFirstName,
  setFormFirstName,
  formLastName,
  setFormLastName,
  isLoading,
}) => {
  const { t } = useTranslation();

  const rules = {
    email: [
      {
        required: true,
        type: "email",
        message: t("form.enter_user_email"),
      },
    ],
    firstName: [
      {
        required: true,
        message: t("form.enter_user_firstName"),
      },
    ],
    lastName: [
      {
        required: true,
        message: t("form.enter_user_lastName"),
      },
    ],
  };

  return (
    <Modal
      title={t("add_admin_user")}
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      okText={t("invite")}
      cancelText={t("close")}
      confirmLoading={isLoading}
    >
      <Form
        layout="vertical"
        form={form}
        name="advanced_search"
        className="ant-advanced-search-form"
        initialValues={{
          userRole: roles.admin,
          userRegion: COMPANY_COUNTRY_CODE,
        }}
      >
        <Row gutter={16}>
          <Col lg={12}>
            <Form.Item name="userFirstName" label={t("customer.firstName")} rules={rules.firstName}>
              <Input
                placeholder={t("customer.firstName")}
                value={formFirstName}
                onChange={(e) => setFormFirstName(e.target.value)}
                prefix={<UserOutlined className="site-form-item-icon" />}
              />
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item name="userLastName" label={t("customer.lastName")} rules={rules.lastName}>
              <Input
                placeholder={t("customer.lastName")}
                value={formLastName}
                onChange={(e) => setFormLastName(e.target.value)}
                prefix={<UserOutlined className="site-form-item-icon" />}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col lg={12}>
            <Form.Item name="userEmail" label={t("email")} rules={rules.email}>
              <Input
                placeholder={t("email")}
                value={formEmail}
                onChange={(e) => setFormEmail(e.target.value)}
                prefix={<MailOutlined className="site-form-item-icon" />}
                suffix={
                  <Tooltip title={t("form.add_user_email_tooltip")}>
                    <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                }
              />
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item name={"userPhoneNumber"} label={t("phone")}>
              <Input
                placeholder={t("phone")}
                value={formPhone}
                onChange={(e) => setFormPhone(e.target.value)}
                prefix={<PhoneOutlined className="site-form-item-icon" />}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col lg={12}>
            <Form.Item name="userRole" label={t("role")} rules={rules.role}>
              <Select className="mr-2" defaultValue={roles.user}>
                <Option value={roles.admin}>{t("admin")}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item name="userRegion" label={t("region")}>
              <Select className="mr-2">
                {REGIONS.map((region) => (
                  <Option key={region}>{region}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
